import type { SelectOption } from "./components/Select"

/** 档位 1～3 与产品设计一致；4～6 请按后端/运营含义补全文案 */
export const DND_TIME_SLOT_OPTIONS: SelectOption[] = [
  {
    label: "22:00 - 次日 08:00",
    subLabel: "从 22:00 到次日 08:00",
    value: "1",
  },
  {
    label: "23:00 - 次日 07:00",
    subLabel: "从 23:00 到次日 07:00",
    value: "2",
  },
  {
    label: "21:00 - 次日 09:00",
    subLabel: "从 21:00 到次日 09:00",
    value: "3",
  }
]

export function getDndTimeSlotLabel(slot: number | null | undefined): string {
  const s = typeof slot === "number" ? slot : 1
  const opt = DND_TIME_SLOT_OPTIONS.find((o) => Number(o.value) === s)
  return opt?.label ?? DND_TIME_SLOT_OPTIONS[0].label
}
